import React from 'react';
import { US_STATES } from '../../data/usStates';

export default function DistributorOrderAddress({ address, setAddressField, t }) {
  return (
    <>
      <label className="block text-sm font-medium" htmlFor="distributor-delivery-street">
        {t('Street')}
      </label>
      <input
        id="distributor-delivery-street"
        aria-label={t('Delivery street address')}
        autoComplete="street-address"
        className="me-do-input block w-full"
        maxLength={120}
        required
        value={address.street}
        onChange={(event) => setAddressField('street', event.target.value)}
      />
      <div className="me-do-address-grid grid grid-cols-1 gap-3 sm:grid-cols-[2fr_1fr_1fr]">
        <label className="min-w-0 text-sm">
          {t('City')}
          <input
            aria-label={t('Delivery city')}
            autoComplete="address-level2"
            className="me-do-input block w-full"
            maxLength={80}
            required
            value={address.city}
            onChange={(event) => setAddressField('city', event.target.value)}
          />
        </label>
        <label className="min-w-0 text-sm">
          {t('State')}
          <select
            aria-label={t('Delivery state')}
            autoComplete="address-level1"
            className="me-do-input block w-full"
            required
            value={address.state}
            onChange={(event) => setAddressField('state', event.target.value)}
          >
            <option value="">{t('Select state')}</option>
            {US_STATES.map(([code, name]) => (
              <option key={code} value={code}>
                {name}
              </option>
            ))}
          </select>
        </label>
        <label className="min-w-0 text-sm">
          {t('ZIP code')}
          <input
            aria-label={t('Delivery ZIP code')}
            autoComplete="postal-code"
            className="me-do-input block w-full"
            maxLength={20}
            required
            value={address.zipCode}
            onChange={(event) => setAddressField('zipCode', event.target.value)}
          />
        </label>
      </div>
    </>
  );
}
